import LocalizationEntity from "../entities/LocalizationEntity";

export default interface LocalizationRepository {
    changeLanguage(language: LocalizationEntity): void;
    getLanguage(): Promise<LocalizationEntity>;
    getAvailableLanguages(): Promise<LocalizationEntity[]>;
}

export const LocalizationRepositoryName = 'LocalizationRepository';